/* eslint-disable react/no-danger */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Plus, FileQuestion, Eye, Layers3, Search, ChevronDown } from 'lucide-react';
import ResponsiveTable from '../../../components/Table/Responsivetable';
import ViewChapterModal from './ViewChapterModal';
import adminServices from '../../../services/adminServices';
import useDebounce from '../../../hooks/useDebounce';
import Snackbar from '../../../components/snackbar/snackbar';
import AddChapterDialog from './AddChapterDialog';

const SourceChapters = () => {
  const navigate = useNavigate();
  const { sourceId } = useParams();
  const parsedSourceId = parseInt(sourceId, 10);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [sourceData, setSourceData] = useState(null);
  const [chapters, setChapters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addChapterOpen, setAddChapterOpen] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [chapterToDelete, setChapterToDelete] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [difficultyFilter, setDifficultyFilter] = useState('');
  const [creatorFilter, setCreatorFilter] = useState('');
  const [creatorsList, setCreatorsList] = useState([]);

  const debouncedSearch = useDebounce(searchQuery, 500);

  useEffect(() => {
    fetchAuthors();
  }, []);

  const fetchAuthors = async () => {
    try {
      const response = await adminServices.getAuthors();
      if (response.ok) {
        setCreatorsList(response.data);
      }
    } catch (error) {
      console.error('Error fetching authors:', error);
    }
  };

  useEffect(() => {
    if (parsedSourceId) {
      setPage(1);
      fetchSourceData(1, pageCount, debouncedSearch, difficultyFilter, creatorFilter);
    }
  }, [parsedSourceId, debouncedSearch, difficultyFilter, creatorFilter]);

  const fetchSourceData = async (currentPage = page, currentPageCount = pageCount, search = debouncedSearch, difficulty = difficultyFilter, creator = creatorFilter) => {
    setLoading(true);
    try {
      const response = await adminServices.getSourceChaptersPaginated(
        parsedSourceId,
        currentPage,
        currentPageCount,
        search,
        difficulty,
        creator
      );

      setSourceData(response?.data);
      setChapters(response?.data?.chapters || []);
      setTotalCount(response?.data?.totalCount || 0);
      setTotalPages(response?.data?.pagination?.totalPages || 0);
    } catch (error) {
      console.error('Error fetching source data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    fetchSourceData(newPage, pageCount, debouncedSearch, difficultyFilter, creatorFilter);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePageSizeChange = (newPageCount) => {
    setPageCount(newPageCount);
    setPage(1);
    fetchSourceData(1, newPageCount, debouncedSearch, difficultyFilter, creatorFilter);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const getDifficultyBadgeClass = (difficulty) => {
    const difficultyLower = difficulty?.toLowerCase();
    if (difficultyLower === 'easy') {
      return 'bg-green-100 text-green-700';
    }
    if (difficultyLower === 'medium') {
      return 'bg-yellow-100 text-yellow-700';
    }
    if (difficultyLower === 'hard') {
      return 'bg-red-100 text-red-700';
    }
    if (difficultyLower === 'foundation') {
      return 'bg-blue-100 text-blue-700';
    }
    return 'bg-gray-100 text-gray-700';
  };


  const loadChapterPreview = async (chapter) => {
    setPreviewOpen(true);
    setSelectedChapter({
      ...chapter,
      questionCount: chapter?.questions_count|| 0,
    });
    // setPreviewLoading(true);
    // setSelectedChapter(null);
    // try {
    //   const result = await adminServices.getQuestionsByChapterId(chapter.id);
    //   const chapterDetails = result?.data?.chapterDetails;
    //   const fullQuestions = chapterDetails?.questions || chapter?.questions || [];
    //   const questionTypes = chapterDetails?.questions_types || chapter?.questions_types || [];

    //   setSelectedChapter({
    //     ...chapter,
    //     ...chapterDetails,
    //     questions: fullQuestions,
    //     questions_types: questionTypes,
    //   });
    // } catch (error) {
    //   console.error('Error loading chapter preview:', error);
    //   setSelectedChapter(chapter);
    //   setSnackbarTitle('Failed to load full question details');
    //   setSnackbarOpen(true);
    // } finally {
    //   setPreviewLoading(false);
    // }
  };
  const handleDeleteClick = (chapter) => {
    setChapterToDelete(chapter);
    setDeleteConfirmOpen(true);
  };
  const handleDeleteConfirm = async () => {
    if (!chapterToDelete || deleteLoading) return;

    setDeleteLoading(true);

    try {
      const result = await adminServices.deleteChapterByid(chapterToDelete.id);

      if (result.ok) {
        setSnackbarTitle(result.data.message);
        setSnackbarOpen(true);
        await fetchSourceData(page, pageCount);
      } else {
        setSnackbarTitle(result?.data?.message || 'Failed to delete chapter');
        setSnackbarOpen(true);
      }

    } catch (error) {
      console.error('Error deleting chapter:', error);
      setSnackbarTitle('Failed to delete chapter');
      setSnackbarOpen(true);
    } finally {
      setDeleteLoading(false);
      setDeleteConfirmOpen(false);
      setChapterToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmOpen(false);
    setChapterToDelete(null);
  };

  const handleActionClick = async (action, chapter) => {
    switch (action) {
      case 'preview':
        await loadChapterPreview(chapter);
        break;
      case 'questions':
        console.log('View questions:', chapter);
        navigate(`/app/chapter-questions/${chapter.id}`);
        break;
      case 'edit':
        setSelectedChapter(chapter);
        setAddChapterOpen(true);
        break;
      case 'delete':
        handleDeleteClick(chapter);
        break;
      default:
        break;
    }
  };

  const handleAddChapter = () => {
    setAddChapterOpen(true);
  };

  const columns = [
    {
      label: 'Chapter Name',
      key: 'chapter_name',
      accessor: (row) => row.module_name,
      cellClassName: 'text-sm font-semibold text-gray-900',
    },
    {
      label: 'Difficulty',
      key: 'difficulty',
      render: (row) => (
        <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium uppercase ${getDifficultyBadgeClass(row.complexity_level)}`}>
          {row.complexity_level}
        </span>
      ),
    },
    {
      label: 'Questions',
      key: 'questions',
      headerClassName: 'text-center',
      cellClassName: 'text-center',
      render: (row) => (
        <div className="flex items-center justify-center gap-1.5">
          <FileQuestion size={16} className="text-gray-500" />
          <span className="text-sm text-gray-900 font-medium">
            {row.questions_count || 0}
          </span>
        </div>
      ),
    },
    {
      label: 'Created By',
      key: 'created_by',
      render: (row) => (
        <div className="flex flex-col">
          <span className="text-sm text-gray-900">
            {row.created_by_name || '-'}
          </span>
          {row.created_date && (
            <span className="text-xs text-gray-400 mt-0.5">
              {new Date(row.created_date).toLocaleDateString('en-US', {
                month: 'short', day: '2-digit', year: 'numeric',
              })}, {new Date(row.created_date).toLocaleTimeString('en-US', {
                hour: '2-digit', minute: '2-digit', hour12: true,
              })}
            </span>
          )}
        </div>
      ),
    },
    {
      label: 'Last Edited',
      key: 'last_edited',
      render: (row) => {
        // if (!row.modify_date) {
        //   return <span className="text-sm text-gray-400">Never edited</span>;
        // }
        console.log(row,"rowrowrowrowrowrow");
        
        return (
          <div className="flex flex-col">
            <span className="text-sm text-gray-900">
              {row.updated_by_name || '-'}
            </span>

            {row.updated_by ? 
            <span className="text-xs text-gray-400 mt-0.5">
              {new Date(row.modify_date).toLocaleDateString('en-US', {
                month: 'short', day: '2-digit', year: 'numeric',
              })}, {new Date(row.modify_date).toLocaleTimeString('en-US', {
                hour: '2-digit', minute: '2-digit', hour12: true,
              })}
            </span>: <span className="text-xs text-gray-400 mt-0.5">-</span>}
          </div>
        );
      },
    },
    {
      label: 'Actions',
      key: 'actions',
      headerClassName: 'text-right',
      cellClassName: 'text-right',
      render: (row, index, onActionClick) => (
        <div className="flex items-center justify-end gap-3 whitespace-nowrap">
          <button
            id={`btn-questions-chapter-${row.id}`}
            onClick={() => onActionClick('questions', row)}
            className="inline-flex items-center gap-1.5 px-2 py-1 text-gray-700 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors duration-150 leading-none"
            title="Questions"
          >
            <FileQuestion size={16} color="black" />
            <span className="text-sm font-medium">Questions</span>
          </button>
          <button
            id={`btn-preview-chapter-${row.id}`}
            onClick={() => onActionClick('preview', row)}
            className="p-2 text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors duration-150"
            title="Preview"
          >
            <Eye size={18} />
          </button>

            <button
              id={`btn-edit-chapter-${row.id}`}
              onClick={() => onActionClick('edit', row)}
              className="p-2 text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors duration-150"
              title="Edit"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </button>
        

            <button
              id={`btn-delete-chapter-${row.id}`}
              onClick={() => onActionClick('delete', row)}
              className="p-2 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors duration-150"
              title="Delete"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
         
        </div>
      ),
    },
  ];

  const TitleSkeleton = () => {
    return (
      <div className="space-y-3 animate-pulse">
        <div className="h-8 bg-gray-200 rounded" />
      </div>
    );
  };

  const renderEmptyChapterState = () => (
    <div className="w-full">
      <div className="hidden lg:grid grid-cols-4 border-b border-gray-200 bg-gray-50">
        <div className="px-6 py-3 text-xs font-semibold text-gray-600 tracking-wider">Chapter Name</div>
        <div className="px-6 py-3 text-xs font-semibold text-gray-600 tracking-wider">Difficulty</div>
        <div className="px-6 py-3 text-xs font-semibold text-gray-600 tracking-wider text-center">Questions</div>
        <div className="px-6 py-3 text-xs font-semibold text-gray-600 tracking-wider text-right">Actions</div>
      </div>

      <div className="py-16 px-6 flex flex-col items-center justify-center">
        <Layers3 size={58} className="text-slate-300 mb-3" />
        <p className="text-gray-500 text-sm mb-5">No chapters yet</p>
        <button
          type="button"
          id="add-first-chapter-btn"
          onClick={handleAddChapter}
          className="px-5 py-2 border border-gray-300 text-gray-800 bg-white hover:bg-gray-50 rounded-lg font-medium transition-colors"
        >
          Add Your First Chapter
        </button>
      </div>
    </div>
  );

  return (
    <>
      <div className="min-h-screen mt-12 bg-gray-50 p-4 sm:p-6 lg:p-8">
        <div className="mx-auto">
          {/* Back Button */}
          <button
            id="back-to-source-btn"
            onClick={() => navigate('/app/sources')}
            className="flex items-center gap-2 text-gray-700 hover:text-gray-900 mb-6 transition-colors"
          >
            <ArrowLeft size={20} />
            <span className="font-medium">Back to Source</span>
          </button>

          {/* Header Section */}
          <div className="mb-6">
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
              <div>
                <h1 className="text-3xl font-bold text-gray-900 mb-2">
                  {sourceData?.title || <TitleSkeleton />}
                </h1>
                <p className="text-gray-600 mb-3">
                  {sourceData?.description || 'Manage chapters and organize content'}
                </p>
                <div className="flex items-start gap-2 ">
                  {/* <span className="inline-flex items-center justify-center w-5 h-5 rounded-sm bg-blue-100 text-blue-700 text-xs font-bold flex-shrink-0">
                    i
                  </span> */}
                  <p
                    className="text-sm text-indigo-600 break-words"
                    title={sourceData?.title || 'this source'}
                  >
                    ℹ️ Chapters added here will be tagged directly to  "{sourceData?.title || 'this source'}"
                  </p>
                </div>
              </div>
              <div className="flex-shrink-0">
                <button
                  id="add-chapter-btn"
                  onClick={handleAddChapter}
                  className="inline-flex items-center justify-center px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors duration-150 shadow-sm whitespace-nowrap"
                >
                  <Plus size={20} className="mr-2" strokeWidth={2.5} />
                  Add Chapter
                </button>
              </div>
            </div>
          </div>

          {/* Search & Filters */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
            <div className="flex flex-col md:flex-row gap-3">
              {/* Search */}
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
                <input
                  id="chapter-search-input"
                  type="text"
                  placeholder="Search chapters..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                />
              </div>

              {/* Difficulty Filter */}
              <div className="relative w-full md:w-48">
                <select
                  id="chapter-difficulty-filter"
                  value={difficultyFilter}
                  onChange={(e) => { setDifficultyFilter(e.target.value); setPage(1); }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm appearance-none bg-white"
                >
                  <option value="">All Difficulties</option>
                  <option value="Easy">Easy</option>
                  <option value="Medium">Medium</option>
                  <option value="Hard">Hard</option>
                </select>
                <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={16} />
              </div>

              {/* Creator Filter */}
              <div className="relative w-full md:w-48">
                <select
                  id="chapter-creator-filter"
                  value={creatorFilter}
                  onChange={(e) => { setCreatorFilter(e.target.value); setPage(1); }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm appearance-none bg-white"
                >
                  <option value="">All Creators</option>
                  {creatorsList.map((creator) => (
                    <option key={creator.id} value={creator.id}>
                      {creator.name}
                    </option>
                  ))}
                </select>
                <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={16} />
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <ResponsiveTable
              columns={columns}
              data={chapters}
              loading={loading}
              onActionClick={handleActionClick}
              emptyStateComponent={renderEmptyChapterState}
            />

            {chapters.length > 0 && (
              <div className="px-4 py-3 border-t border-gray-200 sm:px-6">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                  <div className="text-sm text-gray-700">
                    Showing <span className="font-medium">{(page - 1) * pageCount + 1}</span> to{' '}
                    <span className="font-medium">
                      {Math.min(page * pageCount, totalCount)}
                    </span>{' '}
                    of <span className="font-medium">{totalCount}</span> results
                  </div>

                  <div className="flex items-center gap-2">
                    <select
                      id="chapter-page-size-select"
                      value={pageCount}
                      onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                      className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>

                    <button
                      id="chapter-pagination-prev-btn"
                      onClick={() => handlePageChange(page - 1)}
                      disabled={page === 1}
                      className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150"
                    >
                      Previous
                    </button>

                    {totalPages > 1 && (
                      <div className="hidden sm:flex items-center gap-1">
                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                          let pageNum;
                          if (totalPages <= 5) {
                            pageNum = i + 1;
                          } else if (page <= 3) {
                            pageNum = i + 1;
                          } else if (page >= totalPages - 2) {
                            pageNum = totalPages - 4 + i;
                          } else {
                            pageNum = page - 2 + i;
                          }

                          return (
                            <button
                              key={i}
                              id={`chapter-page-btn-${pageNum}`}
                              onClick={() => handlePageChange(pageNum)}
                              className={`px-3 py-1.5 border rounded-lg text-sm font-medium transition-colors duration-150 ${page === pageNum
                                ? 'bg-indigo-600 text-white border-indigo-600'
                                : 'border-gray-300 text-gray-700 hover:bg-gray-50'
                                }`}
                            >
                              {pageNum}
                            </button>
                          );
                        })}
                      </div>
                    )}

                    <button
                      id="chapter-pagination-next-btn"
                      onClick={() => handlePageChange(page + 1)}
                      disabled={page === totalPages || totalPages === 0}
                      className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150"
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Add Chapter Dialog */}
      <AddChapterDialog
        open={addChapterOpen}
        onClose={() => {
          setAddChapterOpen(false);
          setSelectedChapter(null);
        }}
        assessmentSourceId={parsedSourceId}
        moduleType={sourceData?.type}
        userId={1527}
        onSuccess={fetchSourceData}
        onNotify={(message) => {
          setSnackbarTitle(message);
          setSnackbarOpen(true);
        }}
        editData={selectedChapter}
      />

      {previewOpen && (
        <ViewChapterModal
          open={previewOpen}
          onClose={() => {
            setSelectedChapter(null);
            // setPreviewLoading(false);
            setPreviewOpen(false);
          }}
          chapter={selectedChapter}
          sourceName={sourceData?.title || sourceData?.short_description}
          getDifficultyBadgeClass={getDifficultyBadgeClass}
        />
      )}
      <Snackbar open={snackbarOpen} snackbarTitle={snackbarTitle} close={handleSnackbarClose} />
      {deleteConfirmOpen && (
        <div id="delete-chapter-confirm-modal" className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-96">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Delete Chapter</h3>
            <p className="text-sm text-gray-600 mb-6">Are you sure you want to delete &quot;{chapterToDelete?.module_name}&quot;? This action cannot be undone.</p>
            <div className="flex justify-end gap-3">
              <button type="button" id="delete-chapter-cancel-btn" onClick={handleDeleteCancel} className="px-4 py-2 text-sm border border-gray-300 rounded-md">Cancel</button>
              <button type="button" id="delete-chapter-confirm-btn" disabled={deleteLoading} onClick={handleDeleteConfirm} className={`px-4 py-2 text-sm rounded-md text-white flex items-center justify-center ${deleteLoading ? 'bg-red-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}`}>
                {deleteLoading ? (
                  <>
                    <svg className="animate-spin h-4 w-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z" />
                    </svg>
                    Deleting...</>) : ('Delete')}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SourceChapters;